const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  status: "",
  searchTerm: "",
  sortBy: "",
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    changeStatus: (state, action) => {
      state.status = action.payload;
    },
    changeSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    changeSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
  },
});

export default filtersSlice.reducer;
export const { changeSearchTerm, changeSortBy, changeStatus } =
  filtersSlice.actions;
